export function tokenize(endpoint) {
    return `${endpoint}?token=${localStorage.getItem('token') || ''}`;
}


// WEBPACK FOOTER //
// ./src/helpers/token.js